import { View } from "../../../../types/Views";

type ViewName = keyof typeof View;

export interface IGoogleTagsManagerEvent {
  event: string;
}

export class GoogleTagsManagerStepArrivalEvent implements IGoogleTagsManagerEvent {
  readonly event: string;
  readonly step_name: string;
  readonly page_location: string;

  constructor(event: string, stepName: string, page_location: string) {
    this.event = event;
    this.step_name = stepName;
    this.page_location = page_location;
  }
}

export class GoogleTagsManagerViewArrivalEvent implements IGoogleTagsManagerEvent {
  readonly event: string;
  readonly view_name: ViewName;
  readonly page_location: string;

  constructor(event: string, view: View, page_location: string) {
    this.event = event;
    this.view_name = View[view] as ViewName;
    this.page_location = page_location;
  }
}
